import React from 'react';
import DlpAcitve from '../../../Utility/Icons/DlpActive';
import DlpInactive from '../../../Utility/Icons/DlpInactive';

interface DlpToggleProps {
    dlpActive: boolean;
    handleDlpActiveCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function DlpToggle({ dlpActive, handleDlpActiveCheckbox }: DlpToggleProps) {
    return (
        <div className={`h-[56px] flex justify-center items-center min-w-[40px]`}>
            <input
                className="hidden"
                id="dlp-check"
                type="checkbox"
                checked={dlpActive}
                onChange={handleDlpActiveCheckbox}
            />
            <label
                htmlFor="dlp-check"
                className={`text-chatInput-inlineButtonColor toolTipTarget relative absolute border-none rounded-s duration-300`}
            >
                {dlpActive ? (
                    <DlpAcitve size={24} color="currentColor" />
                ) : (
                    <DlpInactive size={24} color="currentColor" />
                )}
            </label>
        </div>
    );
}
